import { ReactNode, useEffect, useState } from "react";
import { useRouter } from "next/router";
import { useHotkeys } from "react-hotkeys-hook";
import { classes } from "lib/actions/util";
import { DivProps } from "react-html-props";
import ExpandSvg from "./icons/expand.svg";
import CollapseSvg from "./icons/collapse.svg";

export default function Collapsible({
  className,
  children,
  ...rest
}: Omit<DivProps, "children"> & {
  children: ReactNode | ((isExpanded: boolean) => ReactNode);
}) {
  const [isExpanded, setExpanded] = useState(true);
  const router = useRouter();

  const isChildrenFunc = typeof children === "function";

  useHotkeys("[", () => {
    setExpanded((c) => !c);
  });

  useEffect(() => {
    function handler() {
      setExpanded(true);
    }
    router.events.on("routeChangeComplete", handler);
    return function cleanup() {
      router.events.off("routeChangeComplete", handler);
    };
  }, []);

  return (
    <div className={classes("relative", className)} {...rest}>
      {isChildrenFunc ? children(isExpanded) : isExpanded && children}
      <div className="absolute inset-y-0 right-0 flex w-0 flex-col justify-center overflow-visible">
        <button
          type="button"
          aria-label="expand side panel"
          className="z-10 box-content w-5 rounded-r-md bg-white py-3 pl-5 pr-3 shadow-r-md"
          onClick={() => setExpanded((c) => !c)}
        >
          {isExpanded ? <CollapseSvg /> : <ExpandSvg />}
        </button>
      </div>
    </div>
  );
}
